import { StarBoldOutlineBannerRatingGiven } from '@icons/StarBoldOutlineBannerRatingGiven';
import { StarBoldSmallOutlineBannerRatingGiven } from '@icons/StarBoldSmallOutlineBannerRatingGiven';
import { StarBoldOutlineBanner } from '@icons/StarBoldOutlineBanner';
import { StarBoldSmallOutlineBanner } from '@icons/StarBoldSmallOutlineBanner';
import { Text as Paragraph } from '../../Typography';
import React from 'react';
import { IRatingBanner } from '../index';
import { StarBolder } from './StarBolder';

export const StarsButtonContent = ({
  ratingData,
  settingRateData,
}: Pick<IRatingBanner, 'ratingData' | 'settingRateData'>) => {
  const rows = [];
  const rowsSM = [];

  for (let i = 0; i < 5; i += 1) {
    if (settingRateData.isRatingGiven) {
      if (i + 1 <= settingRateData.ratingGiven) {
        rows.push(
          <StarBolder>
            <StarBoldOutlineBannerRatingGiven />
          </StarBolder>,
        );
        rowsSM.push(
          <StarBolder isMobile>
            <StarBoldSmallOutlineBannerRatingGiven />
          </StarBolder>,
        );
      } else {
        rows.push(
          <StarBolder>
            <StarBoldOutlineBanner />
          </StarBolder>,
        );
        rowsSM.push(
          <StarBolder isMobile>
            <StarBoldSmallOutlineBanner />
          </StarBolder>,
        );
      }
    } else {
      rows.push(
        <StarBolder>
          <StarBoldOutlineBanner />
        </StarBolder>,
      );
      rowsSM.push(
        <StarBolder isMobile>
          <StarBoldSmallOutlineBanner />
        </StarBolder>,
      );
    }
  }
  return (
    <>
      <span className="sr-only">{ratingData.rate_this || 'Rate the recipe'}</span>
      <span className="md:block sm:hidden mb-2.5">
        <Paragraph
          className="flex justify-center align-center leading-4.5 m-px"
          tag="div"
          type="leadxs"
        >
          {' '}
          {rows}{' '}
        </Paragraph>
      </span>
      <span className="md:hidden sm:block mb-2.5">
        <Paragraph
          className="flex justify-center align-center leading-4.5 m-px"
          tag="div"
          type="leadxs"
        >
          {' '}
          {rowsSM}{' '}
        </Paragraph>
      </span>
    </>
  );
};
